import React from "react";

const PatientAvatar = ({ firstName = "", lastName = "", size = "md" }) => {
  const initials = `${firstName?.[0] || ""}${lastName?.[0] || ""}`.toUpperCase() || "?";
  const sizeClass =
    size === "lg"
      ? "w-12 h-12 text-base"
      : size === "sm"
        ? "w-7 h-7 text-[10px]"
        : "w-9 h-9 text-xs";

  return (
    <div
      className={`${sizeClass} rounded-full bg-indigo-100 text-indigo-700 font-bold flex items-center justify-center shrink-0`}
    >
      {initials}
    </div>
  );
};

export default PatientAvatar;
